import {
  Add,
  CloudSyncOutlined,
  MoreVertOutlined,
  PostAddOutlined,
} from '@mui/icons-material';
import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
} from '@mui/material';
import { useState } from 'react';

import { TourEventBasic } from '@/domain/project-tour-ontour/entities/project-tour-ontour-event.entity';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { translate } from '@/ui/i18n';

import { ModalAddTourEvents } from './modal-add-tour-events/ModalAddTourEvents';
import { ModalImportApiOrfeoTour } from './modal-import-api-orfeo-tour/ModalImportApiOrfeoTour';
import { ModalImportCsv } from './modal-import-csv/ModalImportCsv';
import {
  defaultTourEventFormValues,
  TourEventsFormValues,
} from './tour-event-form-values/TourEventsFormValues';

export function AddTourEventsButtonAndModal({
  sequenceId,
}: {
  sequenceId: number;
}) {
  const [addTourEventsModalOpen, setAddTourEventsModalOpen] = useState(false);
  const [addTourEventsModalInitialValues, setAddTourEventsModalInitialValues] =
    useState<TourEventsFormValues>({ tourEvents: [] });

  const [importCsvModalOpen, setImportCsvModalOpen] = useState(false);
  const [importApiOrfeoModalOpen, setImportApiOrfeoModalOpen] = useState(false);

  const onClickAddTourEvents = () => {
    setAddTourEventsModalOpen(true);
  };
  const onClickImportCsv = () => {
    setImportCsvModalOpen(true);
  };

  const onClickImportApiOrfeo = () => {
    setImportApiOrfeoModalOpen(true);
  };

  const onImportTourEventsBasic = (tourEventsBasic: TourEventBasic[]) => {
    const tourEvents: TourEventsFormValues['tourEvents'] = tourEventsBasic.map(
      (x) => ({
        ...defaultTourEventFormValues,
        name: x.name,
        date: x.date,
        capacity: x.capacity,
        position: x.position,
      }),
    );
    const formValues: TourEventsFormValues = {
      tourEvents,
    };
    setAddTourEventsModalInitialValues(formValues);
    setAddTourEventsModalOpen(true);
  };

  const onImportTourEventsFormValues = (formValues: TourEventsFormValues) => {
    setAddTourEventsModalInitialValues(formValues);
    setAddTourEventsModalOpen(true);
  };

  return (
    <>
      <ActionsMenu
        onClickAddDate={onClickAddTourEvents}
        onClickImportCsv={onClickImportCsv}
        onClickImportApiOrfeo={onClickImportApiOrfeo}
      />
      <ModalAddTourEvents
        open={addTourEventsModalOpen}
        onClose={() => setAddTourEventsModalOpen(false)}
        initialTourEvents={addTourEventsModalInitialValues}
        sequenceId={sequenceId}
      />
      <ModalImportCsv
        open={importCsvModalOpen}
        onClose={() => setImportCsvModalOpen(false)}
        onImportTourEventsFormValues={onImportTourEventsFormValues}
      />
      <ModalImportApiOrfeoTour
        open={importApiOrfeoModalOpen}
        onClose={() => setImportApiOrfeoModalOpen(false)}
        onImportTourEventsBasic={onImportTourEventsBasic}
      />
    </>
  );
}

function ActionsMenu({
  onClickAddDate,
  onClickImportCsv,
  onClickImportApiOrfeo,
}: {
  onClickAddDate: () => void;
  onClickImportCsv: () => void;
  onClickImportApiOrfeo: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>(undefined);

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(undefined);
  };

  const onClickItem = (actionToCall: () => void) => {
    onClose();
    actionToCall();
  };

  return (
    <>
      <FSPrimaryButton startIcon={<MoreVertOutlined />} onClick={onClick}>
        {translate('ProjectsTour.OnTour.add-tour-events-button')}
      </FSPrimaryButton>
      <Menu open={Boolean(anchorEl)} onClose={onClose} anchorEl={anchorEl}>
        <MenuList>
          <MenuItem onClick={() => onClickItem(onClickAddDate)}>
            <ListItemIcon>
              <Add fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              {translate('ProjectsTour.OnTour.add-tour-events-button')}
            </ListItemText>
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => onClickItem(onClickImportCsv)}>
            <ListItemIcon>
              <PostAddOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{translate('Projects.import-csv')}</ListItemText>
          </MenuItem>
          <MenuItem onClick={() => onClickItem(onClickImportApiOrfeo)}>
            <ListItemIcon>
              <CloudSyncOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>
              {translate('Projects.import-api-orfeo')}
            </ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
}
